import React from "react";

export default function TermsAndConditions() {
  return (
    <div className="app-container">
      <div className="background-pattern"></div>

      <div className="main-content">
        <div className="legal-header">
          <img
            src="/logo.png"
            alt="Auto Shiny Counter Logo"
            className="app-logo"
          />
          <h1 className="title">Terms & Conditions</h1>
          <p className="legal-date">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing and using this website, you agree to be bound by
              these Terms and Conditions. If you do not agree to these terms,
              please do not use this website.
            </p>
          </section>

          <section className="legal-section">
            <h2>Description of Website</h2>
            <p>
              This website serves as an informational landing page for the Auto
              Shiny Counter mobile application. It provides information about
              the app, download links to app stores, and a donation option. The
              website does not provide any interactive services or collect user
              data.
            </p>
          </section>

          <section className="legal-section">
            <h2>Use License</h2>
            <p>
              Permission is granted to view and browse this website for
              personal, non-commercial use only. Under this license you may not:
            </p>
            <ul>
              <li>Modify or copy the website materials without permission</li>
              <li>
                Use the materials for any commercial purpose without
                authorization
              </li>
              <li>
                Attempt to reverse engineer or extract source code from the
                website
              </li>
              <li>
                Remove any copyright or other proprietary notations from the
                materials
              </li>
              <li>
                Use automated tools to scrape or harvest content from this
                website
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Disclaimer</h2>
            <p>
              The information provided on this website is for general
              informational purposes only. While we strive to keep the
              information up to date and correct, we make no representations or
              warranties of any kind about the completeness, accuracy,
              reliability, or availability of the information on this website.
            </p>
          </section>

          <section className="legal-section">
            <h2>External Links</h2>
            <p>
              This website contains links to external services including app
              stores and donation platforms. We have no control over the content
              and practices of these sites and cannot accept responsibility or
              liability for their respective privacy policies or terms of
              service.
            </p>
          </section>

          <section className="legal-section">
            <h2>Limitations of Liability</h2>
            <p>
              In no event shall the website owner be liable for any damages
              (including, without limitation, damages for loss of data or
              profit, or due to business interruption) arising out of the use or
              inability to use this website, even if we have been notified of
              the possibility of such damage.
            </p>
          </section>

          <section className="legal-section">
            <h2>Accuracy of Materials</h2>
            <p>
              The materials appearing on this website could include technical,
              typographical, or photographic errors. We do not warrant that any
              of the materials on this website are accurate, complete, or
              current. We may make changes to the materials at any time without
              notice.
            </p>
          </section>

          <section className="legal-section">
            <h2>Modifications</h2>
            <p>
              We may revise these terms of service at any time without notice.
              By using this website, you are agreeing to be bound by the then
              current version of these terms of service.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Information</h2>
            <p>
              If you have any questions about these Terms and Conditions, you
              can contact us through publicly available contact methods or app
              store reviews.
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <a href="/" className="back-link">
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}
